import { createAction } from 'typesafe-actions';
import type { Encoders } from '@studio/types';
import { ActionTypes } from './types';

export const set = {
  updatingEncoders: createAction(ActionTypes.SET_UPDATING_ENCODERS)<Encoders.Derived.CombinedEncoder>(),
  encoders: createAction(ActionTypes.SET_ENCODERS)<Encoders.Derived.CombinedEncoder[]>(),
  removeUpdatingEncoderId: createAction(ActionTypes.REMOVE_UPDATING_ENCODER_ID)<string>(),
};
